<template>
  <vue-scroll :ops="ops" ref="vs" @handle-scroll="handleScroll">
    <div class="teCon">
      <first-Component  class="header" :class="{active:!isShowNav}"  style="position: absolute;top:0;z-index: 999;background-color: white;" :num=4 ></first-Component>

      <first-Component class="animated bounceInDown" style="position: fixed;
    z-index: 999999;
    background-color: white;animation-duration:3s;" :num=4 v-if="!isShowNav"></first-Component>

      <div class="banner animated zoomIn" id="d1">
            <div class="text">
              <span>{{$t('home[2]')}}</span>
            </div>
            <img  style="width:100%;height:100%;cursor: pointer;display: block" src="../assets/Pro.png">
            <div class="threeBtn">
              <span :style="select2===0?oneStyle:''"  @click="showCon(0)">{{$t('teList[0]')}}</span>
              <span :style="select2===1?oneStyle:''" @click="showCon(1)">{{$t('teList[1]')}}</span>
              <span :style="select2===2?oneStyle:''" @click="showCon(2)">{{$t('teList[2]')}}</span>
            </div>
      </div>
      <div class="rd" v-if="select2===0">
        <div class="title wow fadeInUp">
          <p>{{$t('teList[0]')}}</p>
          <div class="three">
            <span style="left: 0"></span>
            <img src="../assets/d.png" alt="">
            <span style="right: 0;"></span>
          </div>

        </div>
        <div class="one ">
          <img src="../assets/adult-3368246.png" alt="">
          <div class="text wow fadeInUp">
            <p>{{$t('Tech').TITLE1}}</p>
            <p>
              {{$t('Tech').content1}}
            </p>
          </div>
        </div>
        <div class="one">
          <img src="../assets/engineer-4054593.png" alt="">
          <div class="text wow fadeInUp">
            <p>{{$t('Tech').TITLE2}}</p>
          <p>
            {{$t('Tech').content2}}
          </p>
          </div>
        </div>
      </div>
      <div class="eq animated zoomIn" v-else-if="select2===1">
        <div class="title">
          <p>{{$t('teList[1]')}}</p>
          <div class="three">
            <span style="left: 0"></span>
            <img src="../assets/d.png" alt="">
            <span style="right: 0;"></span>
          </div>

        </div>
        <div class="mainInfo">
          <div class="item" v-for="(item,index) in $t('Eq')" :key="index">
            <p>{{item.TITLE}}</p>
             <p>{{item.content}}</p>
          </div>
        </div>
      </div>
      <div class="qu animated fadeInLeft" v-else>
        <div class="title">
          <p>{{$t('teList[2]')}}</p>
          <div class="three">
            <span style="left: 0"></span>
            <img src="../assets/d.png" alt="">
            <span style="right: 0;"></span>
          </div>

        </div>
        <div class="one">
          <div class="text">
            <p class="a">{{$t('Qu.one.con1')}}</p>
            <p class="b">{{$t('Qu.one.con2')}}</p>
          </div>
          <div class="text">
            <p class="a">{{$t('Qu.two.title')}}</p>
            <p class="b">
              {{$t('Qu.two.con')}}</p>
            <a v-for="item in $t('Qu.two.arr')">{{item}}</a>
<!--            <a>•	Provide best-in-class products and services</a>-->
<!--            <a>•	Continuous improvement approach to all aspects of the business</a>-->
<!--            <a>•	Motivate, train and educate all employees</a>-->
<!--            <a>•	Provide an environment that supports teamwork and personal growth</a>-->
            <p class="b tb"> {{$t('Qu.three.title')}}</p>
            <a v-for="item in $t('Qu.three.arr')">{{item}}</a>
<!--            <a>•	ISO 9001</a>-->
<!--            <a>•	ISO 14001</a>-->
<!--            <a>•	Unsurpassed warranty performance</a>-->

          </div>
        </div>
        <img class="bgImg" src="../assets/st.png" alt="">
      </div>
      <foot-Component @gotoTop="gotoTop"></foot-Component>
    </div>
  </vue-scroll>
</template>

<script>
  import firstComponent from './first'
  import footComponent from './foot'
  import  {WOW} from 'wowjs'
    export default {
        name: "tech",
      data(){
          return{
            isShowNav:true,
            content:[
              {title:"Manufacturing Excellence",con:"\n" +
                  "                            The highest standards produce the best quality BY MOTOR 's motor business leadership begins at our Technology Center with the foremost advanced development and check facilities. it's equipped with the newest in analytical testing utilized \n" +
                  "in a heavy programme that puts our merchandise through serious conditions for extended periods of your time.\n" +
                  "                        "},
              {title:"Technology Center Capabilities",con:"\n" +
                  "                            Full warrant analysis and tear-down capability; warranty lessons learned are reviewed with all business units and producing locations via BY MOTOR system\n" +
                  "ISO 9001 and ISO 14001, and several of the best quality ratings from the world’s leading automakers\n" +
                  "                        "},
              {title:"Proactive approach to analyzing performance trends",con:"\n" +
                  "                            Monthly review by every business unit for in progress analysis of trends, claims and failures; outline reportable in Monthly Quality Review with plant quality and management\n" +
                  "Weekly reviews of came back half analysis among style engineering, plant warrant cluster and plant quality\n" +
                  "Formalized Corrective Action System to handle new problems\n" +
                  "                        "}
            ],
            ops: {
              vuescroll: {
                mode: 'native',
                sizeStrategy: 'percent',
                detectResize: true
              },
              scrollPanel: {
                speed: 300,
                scrollingX: false,
              },
              rail: {
                background: '#01a99a',
                opacity: 0,
                size:'2px'
              },
              bar: {
                showDelay: 500,
                background: '#0C3665',
                size: '2px',
              }
            },
            select2:0,
            oneStyle:{
              backgroundColor:' #0C3665',
              color:'white'
            },
          }
      },
      components:{firstComponent,footComponent},
      mounted(){
        if(this.$route.query.select!=undefined){
          this.select2=this.$route.query.select
        }else{
          console.log("路由跳转参数为空")
        }
        this.wow=new WOW();
        this.wow.init()
      },
      methods:{
        gotoTop(){
          this.$refs['vs'].scrollIntoView('#d1', 500);
        },
        handleScroll(vertical, horizontal, nativeEvent) {
          let top=vertical.scrollTop
          if(top>0){
            this.isShowNav=false
          }else{
            this.isShowNav=true
          }
          window.pageYOffset=top
          this.wow.scrollHandler()
        },
        showCon(n){
          this.select2=n
        },
      }
    }
</script>

<style lang="scss" scoped>
  .header{
    transition: 1s;
    &.active{
      transform: translateY(-100%);
    }
  }
.teCon{
  width:100%;
  .banner{
    width:100%;
    position: relative;
    .text{
      position: absolute;
      top:60%;
      left: 11%;
      color:white;
      span{
        font-size: 35px;
        font-weight: bold;
        display: inline-block;
        padding-bottom: 10px;
        position: relative;
        border-bottom: 1px solid rgba(255,255,255,.3);
      }
    }
    .threeBtn{
      width:100%;
      color:white;
      position: absolute;
      bottom: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      span{
        display: inline-block;
        width:20%;
        color:#0C3665;
        padding:15px 10px;
        text-align: center;
        margin-left: 0.1%;
        font-weight: bold;
        cursor: pointer;
        background: linear-gradient(top, #0C3665,#0C3665) no-repeat;
        background-size: 100% 0%;
        text-transform: uppercase;
        -webkit-transition: all .5s;
        transition: all .5s;
        background-color:rgba(255,255,255,0.9);
      }
      span:hover{
        background-size: 100% 100%;
        color:white;
      }
    }
  }
  .rd{
   width:100%;
    .title{
      width:100%;
      text-align: center;
      padding-bottom: 60px;
      padding-top: 60px;
      p{
        font-size: 25px;
        font-weight: bold;
        color:#0C3665;
        margin-block-start: 0em;
      }
      .three{
        width:20%;
        height:1px;
        margin: 0 auto;
        position: relative;
        span{
          width:40%;
          display: inline-block;
          height:100%;
          background-color: #ECECEC;
          position: absolute;
        }
        img{
          position: absolute;
          left: 45%;
          top:-10px;
        }
      }
    }
    .one{
      width:1280px;
      margin: 0 auto;
      position: relative;
      height:500px;
      img{
       margin-left: 10%;
        position: absolute;
      }
      .text{
        width:70%;
        position: absolute;
        left: 0;
        top:15%;
        p:first-child{
          font-size: 30px;
          font-weight: bold;
          color:#0C3665;
          text-transform: capitalize;
        }
        p:last-child{
          line-height: 50px;
          font-family: 'light';
        }
      }
    }
  }
  .eq{
    position: relative;
    .title{
      width:100%;
      text-align: center;
      padding-bottom: 60px;
      padding-top: 60px;
      p{
        font-size: 25px;
        font-weight: bold;
        color:#0C3665;
        margin-block-start: 0em;
      }
      .three{
        width:20%;
        height:1px;
        margin: 0 auto;
        position: relative;
        span{
          width:40%;
          display: inline-block;
          height:100%;
          background-color: #ECECEC;
          position: absolute;
        }
        img{
          position: absolute;
          left: 45%;
          top:-10px;
        }
      }
    }
    .mainInfo{
      width:100%;
    background: url("../assets/eq.png") no-repeat;
      background-size: 100% 100%;
      padding-top: 60px;
      padding-bottom: 60px;
      .item{
       width:60%;
        text-align: center;
      margin:80px auto;
        color:white;
        p:first-child{
          font-size: 30px;
          font-weight: bold;
          text-transform: capitalize;
        }
        p:last-child{
          font-size: 18px;
          line-height: 40px;
          font-family: 'light';
        }
      }
    }
  }
  .qu{
    width:100%;
    .title{
      width:100%;
      text-align: center;
      padding-bottom: 60px;
      padding-top: 60px;
      p{
        font-size: 25px;
        font-weight: bold;
        color:#0C3665;
        margin-block-start: 0em;
      }
      .three{
        width:20%;
        height:1px;
        margin: 0 auto;
        position: relative;
        span{
          width:40%;
          display: inline-block;
          height:100%;
          background-color: #ECECEC;
          position: absolute;
        }
        img{
          position: absolute;
          left: 45%;
          top:-10px;
        }
      }
    }
    .one{
     width:90%;
      padding-left: 10%;
      padding-bottom: 60px;
      .text{
        .a{
          font-size: 30px;
          font-weight: bold;
          color:#0C3665;
          text-transform: capitalize;
        }
        .b,a{
          line-height: 40px;
          font-family: 'light';
          width:50%;
        }
        a{
          width:100%;
          display: inline-block;
        }
      }
    }
    .bgImg{
      position: absolute;
      top:15%;
      right:10%;
    }
  }
  @media screen and (max-width: 1366px){
  .rd{
    .one{
      .text{
        width:80%;
        left: 10%;
      }
    }
  }
    .qu{
      .one{
        .text{
          padding-left: 4%;
        }
      }
    }
  }
  @media screen and (max-width:768px){
    .banner{
      img{
        height:500px !important;
        object-fit: cover;
      }
    }
    .rd{
      .one{
        width:100%;
      }
    }
    .qu{
      .bgImg{
        right:-7%;
      }
    }
  }
  @media screen and (max-width:450px){
    .banner{
      .threeBtn{
        flex-direction: column;
        position: static;
        padding-bottom: 30px;
        span{
          width:100%;
          font-size: 10px;
          padding: 10px 5px;
          margin-top: 10px;
          background-color:#FAFAFA;
        }
      }
      .text{
        top:50%;
      }
    }
    .rd{
      .one{
        height:500px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        .text{
          top:0;
          p{
            font-size: 14px;
          }
          p:first-child{
            font-size: 18px;
          }
        }
      }
    }
    .eq{
      .mainInfo{

     background-size: 240% 150%;
        .item{
          width:90%;
          margin-left: 5%;
          p:first-child{
            font-size: 18px;
          }
          p:last-child{
            font-size: 14px;
          }
        }
      }
    }
    .qu{
      .one{
        width:100%;
        margin-left: 0;
        padding-left: 0;
        .text{
          width:90%;
          margin-left: 5%;
          padding-left: 0;
          .a{
            font-size: 20px;
          }
          .b{
            width:100%;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tech.vue